export default __webpack_public_path__ + "static/media/hair-3-0.6aa9f48c.svg";